import { formatPriceString } from "utils/commonUtils";

export const getCartProperties = (cart) => {
  const cartProperties = {};
  const accountLevel = new Map();
  if (cart && Object.keys(cart)?.length) {
    const packages = cart?.packages;
    for (const pkg in packages) {
      const pkgObj = packages[pkg];
      const featureLevel = packages[pkg]?.features;
      switch (pkgObj?.packageType) {
        case "FIVEG":
          cartProperties.FiveG = true;
          break;
        case "FOURG":
          cartProperties.FourG = true;
          break;
        case "ONETALK":
          cartProperties.OneTalk = true;
          break;
        case "REGULAR":
          if (pkgObj?.byod && pkgObj?.emptyByodFromDQ) {
            cartProperties.MobilityByod = true;
            cartProperties.emptyByodFromDQ = true;
            break;
          }
          if (pkgObj?.byod && !pkgObj?.byor) {
            cartProperties.MobilityByod = true;
            break;
          }
          cartProperties.SmartPhones = true;
          break;
        default:
          break;
      }
      cartProperties.isMMW = !!cart?.mwwCart;
      if (!pkgObj?.plan || pkgObj?.plan === "undefined") {
        cartProperties.NoPlan = true;
      }
      if (featureLevel) {
        for (const key of Object.keys(featureLevel)) {
          if (featureLevel[key]?.level === "A") {
            accountLevel.set(key, featureLevel[key]);
          }
        }
      } else if (!featureLevel || featureLevel === "undefined") {
        cartProperties.NoFeature = true;
      }
    }
  }
  cartProperties.AccountLevelFeatures = [...accountLevel.values()];
  return cartProperties;
};

export const getSavingsData = (cart, savingsAemData, type) => {
  if (cart?.packages) {
    const totalAmount = cart?.totalRecurringBicDiscount;
    let bicOneTimeAmount = 0;
    let barCodeOneTimeAmount = 0;
    let maxTenure = 0;
    const modalContentArray = [];
    const modalOneTimeBicContentArray = [];
    let amountAdded = 0;
    let noOfSmartphones = 0;
    const offerSmartphones = new Set();
    let sbdOfferDeviceList = [];
    for (const key in cart.packages) {
      if (cart.packages.hasOwnProperty(key)) {
        const detail = cart.packages[key];
        if (Object.keys(detail.displayDiscountPrice || {}).length) {
          const amount =
            detail.itemPriceWithOutDiscount -
            detail.displayDiscountPrice.itemPrice;
          maxTenure = Math.max(maxTenure, detail.tenure);
          const deviceName =
            (detail.brandName ? detail.brandName + " " : "") +
            detail.productName;
          const modalContent = savingsAemData.modalContent
            .replace("{{amount}}", formatPriceString(amount))
            .replace("{{deviceName}}", deviceName);
          //modalContentArray.push(modalContent);
          const totalAmount = (amount * Number(detail.tenure)).toFixed(2);
          if (totalAmount || amount) {
            modalContentArray.push({
              tenure: detail.tenure,
              modalContent,
              totalAmount,
              amount: formatPriceString(amount),
              packageType: detail?.packageType
            });
          }
        }
        if (detail?.offers?.sbdOffer) {
          sbdOfferDeviceList.push(detail["deviceType"]?.toLowerCase());
        }
        for (const offer in detail.offers?.sbdOffer) {
          // BOVV-106590, if more than one bicNoOfOccurences = 1, take discAmt from the first non-zero amount
          if (detail?.offers?.sbdOffer[offer]?.bicNoOfOccurences === 1 && ((String(detail.packageType).toUpperCase().includes("ONETALK") && (!type || String(type).toUpperCase().includes('ONETALK'))) ||
            (!String(type).toUpperCase().includes('ONETALK') && !String(detail.packageType).toUpperCase().includes("ONETALK")))) {
            bicOneTimeAmount = cart?.bicOneTimeAmount;
            if (
              cart?.groupPackages !== null &&
              cart?.groupPackages &&
              Object.keys(cart?.groupPackages).length
            ) {
              Object.values(cart?.groupPackages).map((grpPack) => {
                if (
                  grpPack["packageIds"]?.includes(key) &&
                  grpPack["deviceCategory"] === detail["deviceCategory"] &&
                  String(grpPack["deviceCategory"])
                    ?.toLowerCase()
                    ?.includes("smartphone")
                ) {
                  amountAdded++;
                  //bicOneTimeAmount =  Number(cart?.bicOneTimeAmount) * Number(grpPack['quantity'])
                  noOfSmartphones++;
                  offerSmartphones.add(key);
                }
              });
            }
            const bicOneTimeModelContent =
              savingsAemData.bicOneTimemodalContent.replace(
                "{{offerdesc}}",
                detail.offers.sbdOffer[offer].offerName
              );
            if (
              modalOneTimeBicContentArray &&
              !modalOneTimeBicContentArray.includes(bicOneTimeModelContent)
            ) {
              modalOneTimeBicContentArray.push(bicOneTimeModelContent);
            }
          }
          if (
            cart?.mixedCart !== null &&
            cart?.mixedCart &&
            String(detail.packageType).toUpperCase().includes("ONETALK") && type !== null && type && String(type).toUpperCase().includes('ONETALK')
          ) {
            if (
              detail?.offers?.sbdOffer[offer]?.bicNoOfOccurences === 1 &&
              detail?.offers?.sbdOffer[offer]?.discAmt
            ) {
              bicOneTimeAmount = detail?.offers?.sbdOffer[offer]?.discAmt;
            }
          }
          //SMBPROS-1223 addition in modal if barcode applied
          if (
            detail?.offers?.sbdOffer[offer]?.bicNoOfOccurences === 1 &&
            detail?.offers?.sbdOffer[offer]?.barcodeId
          ) {
            barCodeOneTimeAmount = detail?.offers?.sbdOffer[offer]?.discAmt;
            const bicOneTimeBarcodeModalContent =
              savingsAemData.bicOneTimeBarcodemodalContent.replace(
                "{{offerdesc}}",
                detail.offers.sbdOffer[offer].offerName
              );
            if (
              modalOneTimeBicContentArray &&
              !modalOneTimeBicContentArray.includes(
                bicOneTimeBarcodeModalContent
              )
            ) {
              modalOneTimeBicContentArray.push(bicOneTimeBarcodeModalContent);
            }
          }
          if (detail.offers.sbdOffer[offer]?.bicBogoOccCode === "BYODRECBIC" || detail?.offers?.sbdOffer[offer]?.bicBogoOccCode === "BKAMT") {
            maxTenure = Math.max(
              maxTenure,
              detail.offers.sbdOffer[offer].bicNoOfOccurences
            );
            const portInDiscAmt =
              detail.offers.sbdOffer[offer].discAmt / maxTenure;
            const deviceName =
              (detail.brandName ? detail.brandName + " " : "") +
              detail.productName;
            const modalContent = savingsAemData.modalContent
              .replace("{{amount}}", formatPriceString(portInDiscAmt))
              .replace("{{deviceName}}", deviceName);
            const totalAmount = (portInDiscAmt * Number(maxTenure)).toFixed(2);
            if (
              detail?.offers?.sbdOffer[offer]?.bicNoOfOccurences &&
              totalAmount
            ) {
              modalContentArray.push({
                tenure: detail?.offers?.sbdOffer[offer]?.bicNoOfOccurences || 0,
                modalContent,
                totalAmount: totalAmount || 0,
              });
            } else {
              modalContentArray.push(modalContent);
            }
          }
        }
      }
    }
    
    bicOneTimeAmount = offerSmartphones?.size
      ? bicOneTimeAmount * offerSmartphones?.size
      : bicOneTimeAmount;
    return {
      totalAmount,
      modalContentArray: [...new Map(modalContentArray.map(item => [item['modalContent'], item])).values()],
      maxTenure,
      bicOneTimeAmount,
      barCodeOneTimeAmount,
      modalOneTimeBicContentArray,
      noOfSmartphones: offerSmartphones?.size,
      sbdOfferDeviceList,
    };
  }
};

export const continueDisabled = (cartPackages) => {
  const isMobilityEdit =
    window?.mbtGlobal?.flags?.ENABLE_VDS3_SHOPPINGCART_MOBILITY_EDIT === "Y"
      ? true
      : false;
  if (!Object.keys(cartPackages)?.length) {
    return true;
  } else {
    for (const i in cartPackages) {
      if (
        (cartPackages[i]?.tradInInfo &&
          !cartPackages[i].tradInInfo?.deviceId) ||
        (cartPackages[i]?.emptyByodFromDQ && isMobilityEdit) ||
        cartPackages[i]?.outOfStock
       
      ) {
        return true;
      }
    }
    if (cartPackages && Object.keys(cartPackages)) {
      let packagesCount = Object.keys(cartPackages)?.length;
      let bussPackagesCount = 0;
      const packages = cartPackages;
      for (const pkg in packages) {
        const pkgObj = packages[pkg];
        if (pkgObj?.buss && pkgObj?.packageType === "IOT") {
          bussPackagesCount += 1;
        }
      }
      if (bussPackagesCount === packagesCount) {
        return false;
      }
    }
  }
  return false;
};

export const tradeInDeviceImeiMissing = (cartPackages) => {
  for (const i in cartPackages) {
    if (
      (cartPackages[i]?.tradInInfo &&
        !cartPackages[i].tradInInfo?.deviceId)
    ) {
      // returning true only if tradeIN device present and tredein device have deviceID missing in DQ
      return true;
    }
    else {
      return false;
    }
  }
}
export const continueText = (cartPackages, t, sessionCartData, vds3CheckoutEnabled = false, isPDPProtectionEnabled = false, isMobile = false) => {
  let continueButton = t("app.common.page-stepper.continue-btn");
  const isSkipAddressActivation = t("app.isSkipAddressActivation", { ns: "app" })
  let continueButtonBool = true;
  if (!Object.keys(cartPackages)?.length) {
    continueButton = t("app.common.page-stepper.continue-btn");
  } else {
    const fivegRouterDevices = ["FIVEGRECEIVER", "FIVEGCBANDROUTER", "FIVEGCBANDROUTER", "FIVEGROUTER"];
    const fourgRouterDevices = ["FOURGROUTER"];
    let flexiblePlanOtherDevice = 0;
    let smartPhoneCount = 0;
    for (const i in cartPackages) {
      const isLaptop = String(cartPackages[i]?.deviceCategory)
        ?.toLowerCase()
        ?.includes("laptop");
      const isSmartWatches =
        String(cartPackages[i]?.deviceCategory)
          ?.toLowerCase()
          ?.includes("smart watches") ||
        String(cartPackages[i].deviceCategory)
          .toLowerCase()
          .includes("smartwatch");
      if (cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("smartphones")) {
        smartPhoneCount += 1;
      }
      if (cartPackages[i]?.plan?.primaryCategory?.toLowerCase()?.includes("flexibleplans")
        && !cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("smartphones")
        && (cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("phones")
          || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("laptop")
          || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("hotspot")
          || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("tablet"))) {
        flexiblePlanOtherDevice += 1;
      }
      const is4GPlanWithoutRouter = !fourgRouterDevices?.includes(String(cartPackages[i]?.deviceType)) && String(cartPackages[i]?.packageType)?.toLowerCase()?.includes("fourg");
      const is5GPlanWithoutRouter = !fivegRouterDevices?.includes(String(cartPackages[i]?.deviceType)) && String(cartPackages[i]?.packageType)?.toLowerCase()?.includes("fiveg");
      if (cartPackages[i]?.packageType === "REGULAR") {
        let protectionPlan;
        if (cartPackages[i]?.features) {
          protectionPlan = Object.values(cartPackages[i]?.features)?.find(
            (e) => e.featureDesc !== "ECONOMIC ADJUSTMENT CHARGE"
          );
        }

        if (
          !cartPackages[i]?.brand &&
          !cartPackages[i]?.deviceId &&
          !cartPackages[i]?.deviceSku &&
          (continueButton !== t("app.common.page-stepper.go-to-plans-btn") ||
            (continueButton !== t("app.common.page-stepper.select-protection-btn-dt")
              || continueButton !== t("app.common.page-stepper.select-protection-btn-mb")
              || continueButton !== t("app.common.page-stepper.select-protection-btn")))
        ) {
          continueButton = t("app.common.page-stepper.select-devices-btn");
          continueButtonBool = false;
        } else if (
          ((cartPackages[i]?.plan &&
            !cartPackages[i]?.features &&
            isSmartWatches) ||
            (cartPackages[i]?.deviceId && cartPackages[i]?.deviceSku &&
              isSmartWatches)) && !(sessionCartData?.e911Address && sessionCartData?.e911Address?.addressLine1)
        ) {
          if ((cartPackages[i]?.plan &&
            !cartPackages[i]?.features) || (cartPackages[i]?.plan && !protectionPlan)) {
            continueButton = isPDPProtectionEnabled ? (
              isMobile ? t("app.common.page-stepper.select-protection-btn-mb")
                : t("app.common.page-stepper.select-protection-btn-dt"))
              : isMobile ? t("app.common.page-stepper.select-protection-btn-mb") : 
              t("app.common.page-stepper.select-protection-btn");
          } else {
            continueButton =
              (isSkipAddressActivation && vds3CheckoutEnabled) ? 
              (isSmartWatches && (cartPackages[i]?.plan?.pricePlanDesc === null || cartPackages[i]?.plan?.pricePlanDesc === undefined)) 
              ? t("app.common.page-stepper.go-to-plans-btn") : 
              t("app.common.page-stepper.continue-btn") :
              t("app.common.page-stepper.go-to-address-activation");
            continueButtonBool = false;
          }
        } else if (
          (cartPackages[i]?.plan === null ||
            cartPackages[i]?.plan === undefined ||
            cartPackages[i]?.plan?.pricePlanDesc === null ||
            cartPackages[i]?.plan?.pricePlanDesc === undefined) &&
          !cartPackages[i]?.buss &&
          continueButton !== t("app.common.page-stepper.select-devices-btn") &&
          continueButton !==
          t("app.common.page-stepper.go-to-address-activation")
        ) {
          continueButtonBool = false;
          continueButton = t("app.common.page-stepper.go-to-plans-btn");
        } else if (
          ((cartPackages[i]?.plan && !cartPackages[i]?.features) ||
            (cartPackages[i]?.plan && !protectionPlan && !isLaptop)) &&
          continueButton !== t("app.common.page-stepper.go-to-plans-btn") &&
          continueButton !== t("app.common.page-stepper.select-devices-btn") &&
          continueButton !==
          t("app.common.page-stepper.go-to-address-activation")
        ) {
          continueButtonBool = false;
          continueButton = isPDPProtectionEnabled ? (
            isMobile ? t("app.common.page-stepper.select-protection-btn-mb")
              : t("app.common.page-stepper.select-protection-btn-dt"))
            : isMobile ? t("app.common.page-stepper.select-protection-btn-mb") : 
             t("app.common.page-stepper.select-protection-btn");
        } else if (
          !!(
            continueButtonBool &&
            sessionCartData?.e911Address &&
            sessionCartData?.e911Address?.addressLine1
          )
        ) {
          continueButton = t("app.common.page-stepper.continue-btn");
        }
      }
      if ((cartPackages[i]?.packageType === 'FOURG' || cartPackages[i]?.packageType === 'FIVEG') && !isLaptop && !isSmartWatches) {
        if ((is4GPlanWithoutRouter || is5GPlanWithoutRouter)) {
          continueButtonBool = false;
          continueButton = t("app.common.page-stepper.select-router-btn");
        }
      }
    }
    if ((flexiblePlanOtherDevice && !smartPhoneCount) &&
      continueButton !== t("app.common.page-stepper.select-devices-btn") &&
      continueButton !== t("app.common.page-stepper.select-protection-btn") &&
      continueButton !== t("app.common.page-stepper.select-protection-btn-dt") &&
      continueButton !== t("app.common.page-stepper.select-protection-btn-mb") &&
      continueButton !== t("app.common.page-stepper.go-to-address-activation")
    ) {
      continueButtonBool = false;
      continueButton = t("app.common.page-stepper.go-to-plans-btn");
    }
  }
  return continueButton;
};

export const isCartHaveUncappedPlan = (cartPackages) => {
  for (let pkg in cartPackages) {
    let pkgObj = cartPackages[pkg];
    if (
      pkgObj?.packageType === "FOURG" &&
      pkgObj?.plan?.planType === "UNCAPPED"
    ) {
      return true;
    }
  }
  return false;
};

export const isCartHaveBussProduct = (cartPackages) => {
  if (!!cartPackages && Object.keys(cartPackages).length === 1) {
    for (let pkg in cartPackages) {
      let pkgObj = cartPackages[pkg];
      if (pkgObj?.buss) {
        return true;
      }
    }
  }
  return false;
};

export const isStandaloneBuss = (sessionCartData) => {
  if (!!sessionCartData?.cart && !!sessionCartData?.cart?.packages && typeof sessionCartData?.cart?.packages == "object") {
    const bussPrducts = Object.values(sessionCartData?.cart?.packages).filter(data => data.buss ? true : false)
    if (bussPrducts.length === Object.keys(sessionCartData?.cart?.packages).length) return true
  }
  return false;
};

export const isFlexibleOtherThanSmartphone = (cartPackages) => {
  let flexiblePlanOtherDevice = 0;
  let smartPhoneCount = 0;
  for (let i in cartPackages) {
    if (cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("smartphones")) {
      smartPhoneCount += 1;
    }
    if (cartPackages[i]?.plan?.primaryCategory?.toLowerCase()?.includes("flexibleplans")
      && !cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("smartphones")
      && (cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("phones")
        || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("laptop")
        || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("hotspot")
        || cartPackages[i]?.deviceCategory?.toLowerCase()?.includes("tablet"))) {
      flexiblePlanOtherDevice += 1;
    }
  }
  if (flexiblePlanOtherDevice && !smartPhoneCount)
    return true;
  else
    return false;
};
